module.exports = __webpack_public_path__ + "static/media/award-title@2x.cca535e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_230/imgs/award-title@2x.png
// module id = 1756
// module chunks = 0